import { render } from "./ProductSelectionSlider.vue?vue&type=template&id=8b012126&scoped=true"
import script from "./ProductSelectionSlider.vue?vue&type=script&lang=js"
export * from "./ProductSelectionSlider.vue?vue&type=script&lang=js"

import "./ProductSelectionSlider.vue?vue&type=style&index=0&id=8b012126&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b012126"]])

export default __exports__